import createRoute      from '@widesk-ui/tools/createRoute';
import ContactTypeModel from '@models/website/ContactTypeModel';

const route = createRoute.dashboardFromModel(
	ContactTypeModel,
	'ContactTypeDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
